import { INonprofitBasedOnFilterOutput} from '../../interfaces/dashboard/iNonprofitBasedOnFilterOutput';

export class NonprofitBasedOnFilterOutput implements INonprofitBasedOnFilterOutput {
	filter: string;
	page: number;

	constructor(nonprofitBasedOnOutput: INonprofitBasedOnFilterOutput = {} as INonprofitBasedOnFilterOutput) {
		this.filter = nonprofitBasedOnOutput.filter;
		this.page = nonprofitBasedOnOutput.page;
	}
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/dashboard/nonprofitBasedOnFilterOutput.ts